import React from 'react';
import classNames from 'classnames';
import hashStr from 'components/common/utilities/hash.js';

function addChildClass(child, childClassName) {
  if (!child || !child.props) {
    return child;
  }

  const className = classNames(child.props && child.props.className, childClassName);

  const props = {
    className,
  };

  return React.cloneElement(child, props);
}

export default function childLayout(ContainerComponent) {
  return props => {
    let { children, ...otherProps } = props;
    const childClassName = `childLayoutContainer_child_${hashStr(JSON.stringify(otherProps), Date.now())}`;
    const wrapperProps = { childClassName, ...props };
    return (
      <ContainerComponent {...wrapperProps}>
        {React.Children.map(props.children, child => addChildClass(child, childClassName))}
      </ContainerComponent>
    );
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/containers/child_layout.jsx